import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import { PRIMARY } from "../../constants";

export function ProfileAreaSectionHeader({ icon: Icon, title, subtitle }) {
  return (
    <Stack direction="row" spacing={1.5} alignItems="flex-start" sx={{ mb: { xs: 4, sm: 5 } }}>
      {Icon ? (
                  <Box
                  aria-hidden
                  sx={{
                    width: { xs: 60, sm: 48 },
                    height: { xs: 60, sm: 48 },
                    borderRadius: "50%",
                    backgroundColor: "#dce6f7",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                  }}
                >
                  <Icon sx={{ color: PRIMARY, fontSize: { xs: 24, sm: 24 } }} />
                </Box>
      ) : null}
      <Box sx={{ minWidth: 0 }}>
        <Typography
          sx={{
            fontFamily: "Rubik, sans-serif",
            fontWeight: 700,
            fontSize: { xs: "1.15rem", sm: "1.35rem" },
            color: PRIMARY,
            textAlign: "left",
            lineHeight: 1.25,
          }}
        >
          {title}
        </Typography>
        {subtitle ? (
          <Typography
            sx={{
              fontFamily: "Rubik, sans-serif",
              fontSize: "0.875rem",
              color: "#97aaaf",
              mt: 0.5,
              textAlign: "left",
              lineHeight: 1.5,
              maxWidth: 720,
            }}
          >
            {subtitle}
          </Typography>
        ) : null}
      </Box>
    </Stack>
  );
}
